// src/components/mantenciones/MantencionHeader.jsx
import React from 'react';
import { theme, Button } from 'antd';
import {
  SaveOutlined,
  CheckCircleOutlined,
  SendOutlined,
  BuildOutlined,
  ExclamationCircleOutlined,
  CloudOutlined,
  DisconnectOutlined,
} from '@ant-design/icons';

const { useToken } = theme;

// saveStatus viene del MaintanceToDoProvider: SIN_CAMBIOS | CON_CAMBIOS |
// GUARDANDO | GUARDADO | ERROR. dirty = hay cambios sin guardar.
function MantencionHeader({
  nro,
  edificio,
  saveStatus,
  onSave,
  onFinish,
  showFinish = true,
  extraAction,
  isOnline = true,
  hasUnsynced = false,
}) {
  const { token } = useToken();
  const isError = saveStatus === 'ERROR';
  const dirty = saveStatus === 'CON_CAMBIOS' || saveStatus === 'GUARDANDO';
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        rowGap: 10,
        flexWrap: 'wrap',
        padding: '12px 4px 16px',
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        marginBottom: 12,
      }}
    >
      <div style={{ flex: '1 1 220px', minWidth: 0 }}>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 7, fontWeight: 600, fontSize: 16 }}
        >
          Mantención
          <span
            className="mono"
            style={{
              fontSize: 11,
              fontWeight: 600,
              padding: '2px 6px',
              borderRadius: token.borderRadiusSM,
              textTransform: 'uppercase',
              color: token.colorPrimary,
              background: token.colorPrimaryBg,
              border: `1px solid ${token.colorPrimaryBorder}`,
            }}
          >
            #{nro}
          </span>
        </div>
        <div
          style={{
            fontSize: 12,
            color: token.colorTextSecondary,
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <BuildOutlined style={{ marginRight: 4 }} />
          {edificio}
        </div>
      </div>

      {/* Acciones: en pantallas anchas van en la misma fila a la derecha; cuando
          no hay ancho, este bloque envuelve a una fila propia (alineado a la
          derecha) en vez de aplastar el título. */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          rowGap: 8,
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          marginLeft: 'auto',
        }}
      >
        {extraAction}

        {!isOnline ? (
          <span
            style={{
              fontSize: 11,
              color: token.colorWarning,
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <DisconnectOutlined /> Sin conexión
          </span>
        ) : hasUnsynced ? (
          <span
            style={{
              fontSize: 11,
              color: token.colorTextTertiary,
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <CloudOutlined /> Sin sincronizar
          </span>
        ) : null}

        <Button
          icon={
            isError ? (
              <ExclamationCircleOutlined />
            ) : dirty ? (
              <SaveOutlined />
            ) : (
              <CheckCircleOutlined />
            )
          }
          type={isError || dirty ? 'primary' : 'default'}
          danger={isError}
          loading={saveStatus === 'GUARDANDO'}
          onClick={onSave}
        >
          {isError ? 'Reintentar' : dirty ? 'Guardar' : 'Guardado'}
        </Button>

        {showFinish && (
          <Button type="primary" icon={<SendOutlined />} onClick={onFinish}>
            Finalizar
          </Button>
        )}
      </div>
    </div>
  );
}

export default MantencionHeader;
